"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Table;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  headline: {
    margin: theme.spacing(0, 0, 2)
  },
  container: {
    maxHeight: 400
  },
  table: {
    minWidth: 650
  }
}));
function Table(props) {
  const {
    addition,
    title,
    textcontent
  } = props.data;
  const css = useStyles();
  if (!(textcontent !== null && textcontent !== void 0 && textcontent.items.length) > 0) {
    return null;
  }
  const {
    items
  } = textcontent;
  const entries = (0, _lodash.map)(items, item => {
    return item.items;
  });
  const headlines = entries[0].map(row => {
    return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      key: row.text,
      align: row["attr-align"],
      dangerouslySetInnerHTML: {
        __html: row.text
      }
    });
  });
  const content = entries.map((row, counter) => {
    if (counter > 0) {
      const cells = row.map((cell, innerCounter) => {
        return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
          key: innerCounter,
          align: cell["attr-align"],
          dangerouslySetInnerHTML: {
            __html: cell.text
          }
        });
      });
      return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
        key: counter
      }, cells);
    } else {
      return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
        key: counter
      });
    }
  });

  // remove table header from content
  content.shift();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h2",
    color: "secondary",
    className: css.headline,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/_react.default.createElement(_core.TableContainer, {
    className: css.container
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    stickyHeader: true,
    className: css.table,
    "aria-label": title
  }, /*#__PURE__*/_react.default.createElement("caption", {
    dangerouslySetInnerHTML: {
      __html: addition
    }
  }), /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, headlines)), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, content))));
}